export default __webpack_public_path__ + "static/media/Bad.f138e6f9.png";